import { App, View } from "@pimo/pimo-app-builder";
import {
  DragAndDropLayout,
  PMCountCategoriesCard,
} from "@pimo/pimo-components";

import { TestAppState } from "../../../app";
import { getDropdownCount } from "../../../utils/dropdown-options";
import { getLocalizedCardCopy } from "../../../utils/get-localized-card-copy";
import {
  getItemName,
  getPluralOfItemName,
} from "../../../utils/get-plural-of-item-name";
import { getProjectName } from "../../../utils/get-plural-of-project-name";
import { isFieldEnabled } from "../../field-enabled";
import { makeGetCardCopy } from "../card-copy";

/** Adds the completion-counts card (#2222). */
export function addCountCompletionCard(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
) {
  const language = app.getAppState().language || "en";
  const getCardCopy = makeGetCardCopy(app);

  const countCompletionComponent = view.addComponent({
    component: PMCountCategoriesCard,
    layoutProps: {
      componentId: "countCompletionComponent",
      labels: ["completion", "count"],
      description: getCardCopy(language, "reportItemCompletionCounts")
        .description,
      title: getCardCopy(language, "reportItemCompletionCounts").title,
    },
  });

  countCompletionComponent.mapState(({ currentReport, settings }) => {
    const completionDefinition =
      settings?.configuration?.degreeOfCompletionDefinition ?? [];

    const completionCounts = Object.entries(
      currentReport?.project?._calculated?.degreeOfCompletionCounts ?? {}
    );
    const data = completionDefinition.map((entry) => ({
      label: entry.name,
      count: getDropdownCount(Object.fromEntries(completionCounts), entry),
      color: entry.color ?? "#000000",
    }));

    return {
      title: getLocalizedCardCopy(language, "reportItemCompletionCounts", {
        itemName: getItemName(settings?.configuration?.itemName, language),
        itemNamePlural: getPluralOfItemName(
          settings?.configuration?.itemName,
          language
        ),
        projectName: getProjectName(
          settings?.configuration?.projectName,
          language
        ),
      }).title,

      data,
      showInfoIcon: false,
      showMenuIcon: false,
    };
  });

  countCompletionComponent.mapVisibility(({ settings }) =>
    isFieldEnabled(settings, "completion", "itemReporting")
  );
}
